import React, { type ReactNode, useState } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Grid, xcss } from '@atlaskit/primitives';
import UFOSegment from '@atlaskit/react-ufo/ufo-segment';
import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';
import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { SearchPageOnboardingSpotlightNew } from '../../../ui/search-page-relay/spotlight';

interface CustomSpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

const gridOverlapStyles = xcss({
	gridRow: 1,
	gridColumn: 1,
});

const spotlightFillStyles = xcss({
	marginTop: 'space.300',
});

const isAboveSmBreakpoint = () => window.innerWidth > 768;

export const CustomSpotlightTarget = ({
	children,
	name,
}: CustomSpotlightTargetProps): React.JSX.Element => {
	const [displaySpotlight] = useState(isAboveSmBreakpoint());

	if (!displaySpotlight) {
		return <React.Fragment>{children}</React.Fragment>;
	}

	return (
		<React.Fragment>
			<PopoverProvider>
				<Grid>
					<Box xcss={gridOverlapStyles}>
						<PopoverTarget>
							<Box xcss={spotlightFillStyles} />
						</PopoverTarget>
					</Box>
					<Box xcss={gridOverlapStyles}>{children}</Box>
				</Grid>
				<UFOSegment name="search-page-onboarding-spotlight">
					<SearchPageOnboardingSpotlightNew />
				</UFOSegment>
			</PopoverProvider>
		</React.Fragment>
	);
};
